import Swiper from 'swiper/bundle';
// import 'swiper/scss/bundle'; // TODO: does not work
import throttle from 'lodash.throttle';
import g from '#core/global';
import load from '#core/load';
import layout from '#core/layout';

// TODO: pull values from styleguide
// import styleguide from '#data/compiled_styleguide' assert { type: 'json' };


const is_active_attr = 'data-is-active';
const slideshow_$ = '.slideshow';
const swiper_container_$ = '.swiper';
const is_coverflow_attr = 'data-swiper-coverflow';
const use_common_caption_attr = 'data-slideshow-common-caption';
const swipers = [];
const slide_caption_$ = 'figcaption';
const slideshow_caption_$ = 'footer';
const slideshow_caption_text_$ = '.c-text';
const slideshow_caption_index_$ = '.c-index';
const true_s = 'true';
const false_s = 'false';

// This must be larger than the caption transition time, as it serves as a
// fallback in case the transition event didn't fire correctly
const time_caption_transition_approx = 500;

let has_slideshow = false;
let $slideshows = null;
let caption_height = 0;


const module = {
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('slideshow-swiper')) return false;
		
		load.content(() => {
			has_slideshow = assign_elements();
			if (!has_slideshow) return false;
			
			window.addEventListener(g.resize_e, throttle(() => {
				update_slideshow_height();
			}, 150));
		});
		load.all(() => {
			has_slideshow = assign_elements();
			if (!has_slideshow) return false;
		});
	},
	
};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_slideshow) return true;
	
	$slideshows = document.querySelectorAll(slideshow_$);
	if (!$slideshows.length) return false;
	
	const base_params = {
		direction: 'horizontal',
		loop: true,
		spaceBetween: 40,
		speed: 360, // TODO: styleguide
		pagination: {
			el: '.swiper-pagination',
		},
		navigation: {
			prevEl: '.slideshow-nav-btn.nav--previous',
			nextEl: '.slideshow-nav-btn.nav--next',
		},
		// autoHeight: true,
		on: {
			afterInit: function () {
				show_caption(this);
			},
			slideChange: function () {
			},
			slideChangeTransitionStart: function () {
				show_caption(this);
			},
			slideChangeTransitionEnd: function () {
			},
		},
	};
	
	const coverflow_params = {
		effect: 'coverflow',
		coverflowEffect: {
			rotate: 0,
			scale: 0.8,
			depth: 0,
			stretch: 16, // Reduce gap between slides
			slideShadows: false,
		},
		centeredSlides: true,
		slidesPerView: 1.8,
		// slidesPerView: 'auto',
	};
	
	$slideshows.forEach($slideshow => {
		const $swiper_container = $slideshow.querySelector(swiper_container_$);
		if (!$swiper_container) return false;
		
		// Remove pagination if using coverflow
		const is_coverflow = $slideshow.hasAttribute(is_coverflow_attr)
		let params = base_params;
		if (is_coverflow) {
			params = (({ pagination, ...params }) => params)(params);
		}
		
		// Combine params
		params = {
			...params,
			...(is_coverflow ? coverflow_params : {}),
		};
		
		// TODO: only load required modules
		swipers.push(new Swiper($swiper_container, params));
	});
	
	return true;
}


/**
 * Show caption
 * @param {Swiper} $slideshow
 * @param {event} e
 */
function show_caption(swiper) {
	const $slideshow = swiper.el.closest(slideshow_$);
	if ($slideshow.getAttribute(use_common_caption_attr) !== true_s) return false;
	
	const $caption = $slideshow.querySelector(slideshow_caption_$);
	const is_caption_active = $caption.getAttribute(is_active_attr);
	if (is_caption_active === false_s) return false;
	
	const real_index = swiper.realIndex;
	const slide_index = swiper.activeIndex;
	const slide_count = swiper.slides.length;
	const $slide = swiper.slides[slide_index];
	const $slide_caption = $slide.querySelector(slide_caption_$);
	const caption_content = ($slide_caption)
		? $slide_caption.innerHTML
		: '';
	
	// After fading out current caption, show new caption
	const update_handler = () => {
		update_caption($caption, caption_content, real_index, slide_count, update_handler);
	};
	$caption.addEventListener(g.transition_end_e, update_handler);
	
	// Fade out current caption
	$caption.setAttribute(is_active_attr, false_s);
	
	// If the transition event doesn't fire correctly, manually check to see if
	// we need to update the caption
	setTimeout(() => {
		if ($caption.getAttribute(is_active_attr) === true_s) return false;
		
		update_caption($caption, caption_content, real_index, slide_count, update_handler);
	}, time_caption_transition_approx);
}


/**
 * Update caption
 * @param {element} $caption
 * @param {string} caption_content
 * @param {int} slide_index
 * @param {int} slide_count
 * @param {function} callback
 */
function update_caption($caption, caption_content, slide_index, slide_count, callback) {
	const $inner = $caption.querySelector(slideshow_caption_text_$);
	const $index = $caption.querySelector(slideshow_caption_index_$);
	$inner.innerHTML = caption_content;
	$index.innerHTML = `<p>${slide_index + 1} / ${slide_count}</p>`;
	update_slideshow_height();
	$caption.removeEventListener(g.transition_end_e, callback);
	$caption.setAttribute(is_active_attr, true_s);
}


/**
 * Update slideshow height as height of caption changes
 */
function update_slideshow_height() {
	$slideshows.forEach($slideshow => {
		const $caption = $slideshow.querySelector(slideshow_caption_$);
		if (!$caption) return false;
		
		const $text = $caption.querySelector(slideshow_caption_text_$);
		const height = Math.round(layout.getHeight($text, false));
		if (height <= caption_height) return false;
		
		caption_height = height;
		layout.setHeight($caption, height);
	});
}
